<xena-modal label="Recalculate sales prices" i18n-label="@@recalculatesSalesPrices_modal_label" style="--width: 38rem;" class="modal-scrolling" [open]="open">
  <form [formGroup]="form">
    <table class="table">
      <thead>
        <tr>
          <th></th>
          <th>
            <label class="checkbox">
              <span class="checkbox__control">
                <input type="checkbox" (change)="toggleSelectAll()" formControlName="isSelected" [indeterminate]="form.get('isIndeterminate').value">
              </span>
              <span class="checkbox__label" i18n="@@recalculatesSalesPrices_articleGroupsLabel">
                ArticleGroups
              </span>
            </label>
          </th>
          <th colspan="3"></th>
        </tr>
      </thead>
      <ng-container formArrayName="articleGroups">
        <tbody *ngFor="let articleGroup of articleGroups.controls" [formGroup]="articleGroup">
          <tr>
            <td class="col-minimum">
              <div class="arrow" (click)="toggleCollapse(articleGroup)">
                <xena-icon [name]="articleGroup.get('isCollapsed').value ? 'fas-chevron-down' : 'fas-chevron-up'"></xena-icon>
              </div>
            </td>
            <td>
              <label class="checkbox article-group-label">
                <span class="checkbox__control">
                  <input type="checkbox" (change)="toggleSelectGroup(articleGroup)" formControlName="isSelected" [indeterminate]="articleGroup.get('isIndeterminate').value">
                </span>
                <span class="checkbox__label">
                  {{ articleGroup.get('description').value }}
                </span>
              </label>
            </td>
            <td class="text-right col-xs-2">{{ articleGroup.get('priceNettTotalSum').value | fixedNumber }}</td>
            <td class="col-minimum"><xena-icon name="fas-long-arrow-alt-right"></xena-icon></td>
            <td class="text-right col-xs-2">{{ articleGroup.get('newPriceNettTotalSum').value | fixedNumber }}</td>
          </tr>
          <ng-container *ngIf="!articleGroup.get('isCollapsed').value" formArrayName="orderLines">
            <tr *ngFor="let orderLine of articleGroup.get('orderLines').controls" [formGroup]="orderLine">
              <td></td>
              <td class="article-indent">
                <label class="checkbox article-group-label">
                  <span class="checkbox__control">
                    <input type="checkbox" (change)="toggleSelect(articleGroup)" formControlName="isSelected">
                  </span>
                  <span class="checkbox__label">
                    {{ orderLine.get('description').value }}
                  </span>
                </label>
              </td>
              <td class="text-right col-xs-2">{{ orderLine.get('priceNettTotal').value | fixedNumber }}</td>
              <td class="col-minimum"><xena-icon name="fas-long-arrow-alt-right"></xena-icon></td>
              <td class="text-right col-xs-2">{{ orderLine.get('newPriceNettTotal').value | fixedNumber }}</td>
            </tr>
          </ng-container>
        </tbody>
      </ng-container>
    </table>
  </form>
  <div slot="footer">
    <div class="d-flex justify-content-between align-items-center">
      <label class="mb-0" i18n="@@recalculatesSalesPrices_adjustPrice_label">Adjust prices by percentage</label>
      <div class="d-flex gap-4 calculate-form">
        <span class="suffix" [formGroup]="form">
          <xena-input class="max-input-size" [number] alignment="right" onfocus="this.getInputElement().then(i => i.select())" formControlName="calculationPercentage">
            <span slot="suffix">%</span>
          </xena-input>
        </span>
        <xena-button slot="footer" (click)="calculate()" type="primary" [disabled]="!enableCalculateButton()" i18n="@@recalculatesSalesPrices_calculateButton">Calculate</xena-button>
      </div>
    </div>
    <xena-panel-divider></xena-panel-divider>
    <div class="d-flex justify-content-between">
      <div>
        <xena-button slot="footer" (click)="resetAll()" mode="ghost" i18n="@@recalculatesSalesPrices_resetAllButton">Reset all</xena-button>
      </div>
      <div class="d-flex gap-3">
        <xena-button slot="footer" (click)="cancel()" mode="ghost" i18n="@@recalculatesSalesPrices_cancelButton">Cancel</xena-button>
        <xena-button slot="footer" (click)="save()" type="primary" i18n="@@recalculatesSalesPrices_saveButton" [loading]="saving">Save</xena-button>
      </div>
    </div>
  </div>
</xena-modal>
